// extracted by mini-css-extract-plugin
export var alt = "SignupModal-module--alt--f3c46";
export var desktopOnly = "SignupModal-module--desktopOnly--d4a32";
export var main = "SignupModal-module--main--cf637";
export var mobileOnly = "SignupModal-module--mobileOnly--93f0c";
export var styledModal = "SignupModal-module--styledModal--145e7";
export var textLeft = "SignupModal-module--textLeft--1d19d";
export var visuallyHidden = "SignupModal-module--visuallyHidden--022b3";